import ClientAddModalComponent from './client-add-component'

/***
 * The modal that pops up on the Client admin to create a new client
 */
const clientAddModal = angular
    .module('FacilityData.ClientAdmin.ClientAddModal', [])
    .component('clientAddModal', ClientAddModalComponent)
    .name;

export default clientAddModal;


// WEBPACK FOOTER //
// ./app/components/client-admin/client-add-modal/client-add-modal.js